module.exports = __webpack_public_path__ + "media/images/responsive/page_common/noimage/landscape/text_gray02-62d84c54ad14104622abb0eed4286a05.png";